import FBPostCRUDActions from '../actions/FBPostCRUDActions';
import {
  setBusy,
  setUnBusy,
  retrievedAll,
  addEntity,
} from './common/commonReducers';
import { FBPostState } from '../interfaces/fbPost';
import FBPostModel from '../model/FBPostModel';

type FBPostAction = {
  type: string;
  entities?: FBPostModel[];
  recommended?: FBPostModel[];
};

const initialState: FBPostState = {
  entities: [],
  recommended: [],
  busy: false,
  specifiedPost: {},
};

const retrievedRecommended = (state: FBPostState, action: FBPostAction) => {
  const { recommended } = action;

  return {
    ...state,
    recommended,
  };
};

function fbPost(state = initialState, action: FBPostAction) {
  switch (action.type) {
    case FBPostCRUDActions.busyAction:
      return setBusy(state);
    case FBPostCRUDActions.unbusyAction:
      return setUnBusy(state);
    case FBPostCRUDActions.retrievedAllAction:
      return retrievedAll(state, action);
    case FBPostCRUDActions.retrievedRecommendedAction:
      return retrievedRecommended(state, action);
    case FBPostCRUDActions.retirievedByIdAction:
      return addEntity(state, action);
    default:
      return state;
  }
}

export default fbPost;
